<script setup lang="ts">
import { defineProps, onMounted, ref } from 'vue'
import { printPhone } from '@/utils/phones'
import ButtonCallTo from '@/components/common/buttons/ButtonCallTo.vue'
import ButtonMailTo from '@/components/common/buttons/ButtonMailTo.vue'
import { DevicePhoneMobileIcon } from '@heroicons/vue/24/outline'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'
const props = defineProps(['params'])
const partnerId = ref()
const phone = ref()
const mobile = ref()
const email = ref()

onMounted(() => {
  partnerId.value = props.params.data.partnerId.id
  phone.value = props.params.data.partnerId.phone
  mobile.value = props.params.data.partnerId.mobile
  email.value = props.params.data.partnerId.email
})
</script>

<template>
  <div class="flex items-center gap-2 w-full">
    <div class="w-10">
      <ButtonCallTo
        :disabled="!phone"
        :partner-id="partnerId"
        :contact-id="params.data.id"
        :phone="printPhone(phone)"
        :tooltip-position="params.tooltipPosition"
      />
    </div>
    <div class="w-10">
      <ButtonCallTo
        :disabled="!mobile"
        :partner-id="partnerId"
        :contact-id="params.data.id"
        :phone="printPhone(mobile)"
        :icon="DevicePhoneMobileIcon"
        :tooltip-position="params.tooltipPosition"
      />
    </div>
    <div class="w-10">
      <ButtonMailTo :disabled="!email" :email="email" :tooltip-position="params.tooltipPosition" />
    </div>
    <div class="w-fit">
      <ButtonDaisy text="Editer" @click="params.onClick(params.data)" />
    </div>
  </div>
</template>
